import { DragDropContext } from 'react-beautiful-dnd';
import PropTypes from 'prop-types';
import React from 'react';

const DragAndDrop = ({ assignProject, children }) => (
  <DragDropContext
    onDragEnd={result => {
      const { type, draggableId, destination } = result;

      if (destination) {
        switch (type) {
          case 'PROJECT': {
            assignProject(draggableId, destination.droppableId);
            break;
          }
          default:
            break;
        }
      }
    }}
  >
    {children}
  </DragDropContext>
);

DragAndDrop.propTypes = {
  assignProject: PropTypes.func
};

export default DragAndDrop;



// WEBPACK FOOTER //
// ./src/components/views/DragAndDrop/index.js